module.exports = __webpack_public_path__ + "static/media/icon-header-profile.6bef1c57.svg";